import * as React from "react"
import * as styles from "./styles.module.scss"

interface JourneyCategoryPageProps {
  category: {
    title: string
    heading: string
  }
  children: React.ReactNode
}

const JourneyCategoryPage: React.FC<JourneyCategoryPageProps> = ({
  category,
  children,
}) => {
  return (
    <div className={styles.startJourney}>
      <div className={styles.pagePadding}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h6 className={styles.eyebrow}>{category.title}</h6>
            <h1 className={styles.heading}>{category.heading}</h1>
          </div>
          <div className={styles.options}>
            <ul className={styles.list}>{children}</ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default JourneyCategoryPage
